import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import { EditRolesModalComponent } from 'app/modules/user-management/component/edit-roles-modal/edit-roles-modal.component';
import { AddRolesModalComponent } from 'app/modules/user-management/component/add-roles-modal/add-roles-modal.component';
import module from 'app/modules/user-management/user-management.module'

@Component({
  selector: 'app-roles-permission',
  templateUrl: './roles-permissions.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./roles-permissions.page.scss']
})
export class RolesPermissionPage {
  public roleDetails$: any = this.userManagementService.roleDetails$

  public filterData = {
    pageNumber: 1,
    pageSize: 10,
    wellName: '',
    reportType: '',
    startDate: null,// new Date(),
    endDate: null
  }

  constructor(
    public dialog: MatDialog,
    private userManagementService : UserManagementService,
  ) {}

  ngOnInit() {
    this.getPermissions() // use in edit roles
    this.getRolesDetails()
  }

  getPermissions(){
    this.userManagementService.getPermissions().subscribe() 
  }

  getRolesDetails(){
    this.userManagementService.getRoleDetails(this.filterData.pageNumber,this.filterData.pageSize).subscribe()
  }

  nextPage() {
    this.filterData.pageNumber = this.filterData.pageNumber + 1
  }

  previousPage() {
    this.filterData.pageNumber = this.filterData.pageNumber - 1
  }

  editRoleModal(roleData: any) {
    const dialogRef = this.dialog.open(EditRolesModalComponent, {
      data: roleData,
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getRolesDetails()
      }
    });
  }

  addRolesModal() {
    const dialogRef = this.dialog.open(AddRolesModalComponent, {
      width: "50%"
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.getRolesDetails()
      }
    });
  }

}
